"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowBackward = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var Icon_styled_1 = require("../Icon.styled");
exports.ArrowBackward = function (props) { return (React.createElement(Icon_styled_1.StyledSvg, tslib_1.__assign({}, props, { viewBox: "0 0 24 24", fill: "none" }),
    React.createElement("path", { d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z", fill: props.fill }))); };
//# sourceMappingURL=arrowbackward.js.map